var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.866 6.5a1 1 0 01-1.732 0L.536 2A1 1 0 011.402.5h5.196A1 1 0 017.464 2L4.866 6.5z",
    fill: "#DCE0E9"
  })));
};
export default __webpack_public_path__ + "static/media/ArrowDown.a39b2ecf.svg";
export { SvgArrowDown as ReactComponent };